/* footer-badges.js — auto-hide the app-store badges' "Coming soon" reveal after a tap/click.
 *
 * WHY THIS EXISTS (supersedes decision B6's "the reveal is CSS-only, no JS"):
 * B6 revealed the label on `:focus`, because a tap focuses the tabindex'd <span> "for free".
 * But focus is sticky by definition — the browser holds it until something else takes it — so
 * on touch and on mouse-click the label stayed up until the reader tapped elsewhere. B6 never
 * anticipated a "hide it after N seconds" requirement; once that exists, CSS alone cannot do it
 * (CSS cannot count time and then undo a state), so a small script owns the pointer path.
 *
 * DIVISION OF LABOUR with footer-panel.css:
 *   - Mice hovering            -> CSS `:hover` (unchanged). Hiding is automatic on mouse-out.
 *   - Keyboard focus           -> CSS `:focus-visible` (unchanged behaviour, now keyboard-only).
 *                                 STAYS sticky on purpose: a keyboard user's reveal must persist
 *                                 while the badge holds focus, and vanish only when they tab away.
 *                                 This script NEVER touches that path — no blur is forced on a
 *                                 keyboard user, so tab order and the focus ring are left intact.
 *   - Tap / mouse-click        -> THIS script: add `.is-revealed`, then remove it after the delay.
 *
 * `:focus-visible` does not match a pointer interaction in modern browsers, so a tap shows the
 * label only through `.is-revealed`, which this script controls. The blur on expiry is belt-and-
 * braces: it clears any lingering focus a tap left behind so the label cannot re-appear.
 *
 * Only badges that still contain a `.rp-footer__soon` child are wired. Per decision B5, publishing
 * an app means swapping that badge's <span> back to <a href> and deleting its `.rp-footer__soon`
 * child — such a badge is skipped here automatically, so "nothing else changes" stays true.
 */
(function () {
    'use strict';

    // The ONLY knob: how long "Coming soon" stays up after a tap/click, in milliseconds.
    var REVEAL_MS = 2500;

    var badges = document.querySelectorAll('.rp-footer__badge');

    Array.prototype.forEach.call(badges, function (badge) {
        // Skip a badge that has been turned into a real store link (no reveal to manage).
        if (!badge.querySelector('.rp-footer__soon')) {
            return;
        }

        var timer = null;

        badge.addEventListener('click', function () {
            badge.classList.add('is-revealed');

            if (timer) {
                clearTimeout(timer);
            }

            timer = setTimeout(function () {
                badge.classList.remove('is-revealed');
                // Drop any focus the tap left behind, so the label cannot linger via :focus-visible.
                if (document.activeElement === badge) {
                    badge.blur();
                }
            }, REVEAL_MS);
        });
    });
}());
